import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/config/api-endpoints';

@Injectable({
  providedIn: 'root'
})

export class ProfileService {

  //private apiURL = 'https://ib-wallet-dev-api.azurewebsites.net/api/DigitalWalletAPI';
  private apiURL = ApiEndpoints.profile;
  
  constructor(private http:HttpClient) { }

  getCustomerProfile(walletID: string, walletRole: string): Observable<any> {
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        "Authorization": "bearer " + wallettoken
      }),
    };
    let sessionID=sessionStorage.getItem("SessionID");
    const url = `${this.apiURL}/dwgetcustomerprofile`;
    return this.http.post<any>(url, { walletID, walletRole ,sessionID},httpOptions);
  }

  setCustomerProfile(data: any): Observable<any> {
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        "Authorization": "bearer " + wallettoken
      }),
    };
    const url = `${this.apiURL}/dwsetcustomerprofile`;
    return this.http.post<any>(url, data,httpOptions);
  }

  getNotificationPreferences(walletID: string, walletRole: string): Observable<any> {
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        "Authorization": "bearer " + wallettoken
      }),
    };
    let sessionID=sessionStorage.getItem("SessionID");
    const url = `${this.apiURL}/dwgetnotificationpreferences`;
    return this.http.post<any>(url, { walletID, walletRole,sessionID },httpOptions);
  }

  setNotificationPreferences(data: any): Observable<any> {
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        "Authorization": "bearer " + wallettoken
      }),
    };
    const url = `${this.apiURL}/dwsetnotificationpreferences`;
    return this.http.post<any>(url, data,httpOptions);
  }

}
